var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgermenuFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.26 26.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec8365;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "burgermen\\xFC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.14,0C5.89,0,0,5.87,0,13.12c0,7.25,5.87,13.14,13.12,13.14,7.25,0,13.14-5.87,13.14-13.12,0,0,0,0,0,0C26.26,5.88,20.39,0,13.14,0Zm1.36,13.71v7.14h-2.95v-7.14h-1.48v-2.43h1.48v-1.54c0-2.01.81-3.2,3.2-3.2h1.97v2.43h-1.23c-.92,0-.98.34-.98.98v1.23h2.23l-.26,2.43-1.98.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgermenuFacebook);
export default __webpack_public_path__ + "static/media/burgermenu_facebook.2934fb60dbaaef64c141151baad3ed8b.svg";
export { ForwardRef as ReactComponent };